import React from 'react';
import Modal from 'react-bootstrap/Modal';
import 'Css/modifica_ospite.css';

const ACCESS_LINK_BASE = 'https://domodroid.app/ms/controlpoint/open?link=';

class ModificaOspite extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      section: 'dettagli',     // 'dettagli' | 'accesso' | 'permessi'
      devices: {},             // { [deviceId]: { ...device, limited: true|null, limitedDate: 'yyyy-MM-ddTHH:mm' } }
      checkDevices: false,
      selectedDevice: null,
      guest: {},               // guest clonato dalle props
      linkCopied: false
    };
    console.log('[ModificaOspite] constructor');
  }

  /* ======================
   * Lifecycle
   * ====================== */
  componentDidMount() {
    console.log('[ModificaOspite] componentDidMount, guestToEdit:', this.props.guestToEdit);
    if (this.props.guestToEdit) this.bootstrapGuest(this.props.guestToEdit);
  }

  componentDidUpdate(prevProps, prevState) {
    const { guestToEdit, devices, generatedPin1 } = this.props;

    // Cambiato ospite in modifica
    if (guestToEdit && (!prevProps.guestToEdit || prevProps.guestToEdit.id !== guestToEdit.id)) {
      console.log('[ModificaOspite] guestToEdit changed:', guestToEdit);
      this.bootstrapGuest(guestToEdit);
    }

    // Rimappa permessi quando cambia guest/devices o non ancora mappato
    const guestChanged = (prevState.guest?.id || null) !== (this.state.guest?.id || null);
    if ((guestChanged || prevProps.devices !== devices || !this.state.checkDevices) &&
        this.state.guest?.id && Array.isArray(devices)) {
      console.log('[ModificaOspite] mapGuestPermissionsToDevices trigger — guestChanged:', guestChanged, 'checkDevices:', this.state.checkDevices, 'devices len:', devices?.length);
      this.mapGuestPermissionsToDevices(this.state.guest, devices);
    }

    // PIN generato
    if (prevProps.generatedPin1 !== generatedPin1 && Array.isArray(this.state.guest?.pin)) {
      console.log('[ModificaOspite] generatedPin1 changed:', generatedPin1);
      this.setState(s => ({ guest: { ...s.guest, pin: [String(generatedPin1 ?? s.guest.pin?.[0] ?? '')] } }));
    }
  }

  /* ======================
   * Utils
   * ====================== */
  utcToLocalInputValue = (utcString) => {
    if (!utcString) return '';
    const date = new Date(utcString);
    const tzOffset = date.getTimezoneOffset() * 60000;
    return new Date(date.getTime() - tzOffset).toISOString().slice(0, 16); // yyyy-MM-ddTHH:mm
  };

  nowLocalForInput = () => {
    const d = new Date();
    const tzOffset = d.getTimezoneOffset() * 60000;
    return new Date(d.getTime() - tzOffset).toISOString().slice(0, 16);
  };

  bootstrapGuest = (guestProp) => {
    const guest = JSON.parse(JSON.stringify(guestProp || {}));
    console.log('[ModificaOspite] bootstrapGuest with:', guest);

    if (guest.id) this.props.getAvailablesRfids?.(guest.id);

    const pinValue = Array.isArray(guest.pin)
      ? (guest.pin.find(p => p && p.value != null)?.value ?? '')
      : '';
    guest.pin = [String(pinValue || '')];
    guest.isUpdate = 'isUpdate';

    this.setState(
      { guest, checkDevices: false, devices: {}, selectedDevice: null },
      () => {
        console.log('[ModificaOspite] bootstrapGuest setState done. Will map devices if available. devices prop len:', this.props.devices?.length);
        this.props.devices?.length && this.mapGuestPermissionsToDevices(guest, this.props.devices);
      }
    );
  };

  mapGuestPermissionsToDevices = (guest, devicesList) => {
    if (!guest?.id || !Array.isArray(devicesList)) {
      console.log('[ModificaOspite] mapGuestPermissionsToDevices — skip (no guest.id or devicesList)');
      return;
    }

    console.log('[ModificaOspite] mapGuestPermissionsToDevices START — guestId:', guest.id, 'devicesList len:', devicesList.length);

    // Costruisci mappa con i device associati all’ospite
    const next = {};
    for (const device of devicesList) {
      const found = Array.isArray(device.guests) ? device.guests.find(g => g?.id === guest.id) : null;
      if (found) {
        const copy = { ...device };
        if (found.expirationDate) {
          copy.limited = true;
          copy.limitedDate = this.utcToLocalInputValue(found.expirationDate);
        } else {
          copy.limited = null;
        }
        next[device.id] = copy;
      }
    }

    console.log('[ModificaOspite] devices mapped for guest (enabled only):', Object.keys(next));

    // Merge non distruttivo (preserva eventuali campi locali)
    this.setState(prev => {
      const merged = {};
      for (const [id, dev] of Object.entries(next)) {
        const prevDev = prev.devices[id] || {};
        merged[id] = { ...dev, link: prevDev.link ?? dev.link };
      }
      console.log('[ModificaOspite] map merge — before:', prev.devices, 'after:', merged);
      return { devices: merged, checkDevices: true };
    });
  };

  /* ======================
   * Link helpers (store-driven)
   * ====================== */
  // key per guestLinks: "guestId::serial"
  linkKey = (guestId, serial) => `${guestId}::${String(serial || '').trim()}`;

  // Legge il link prioritariamente dallo store (guestLinks), altrimenti dal locale
  resolveDeviceLink = (device) => {
    const guestId = this.state.guest?.id;
    const serial  = device?.serialNumber ? String(device.serialNumber).trim() : '';
    const storeMap = this.props.guestLinks; // Map o plain object
    let linkFromStore = null;

    if (guestId && serial && storeMap) {
      const key = this.linkKey(guestId, serial);
      if (typeof storeMap.get === 'function') {
        linkFromStore = storeMap.get(key);
      } else {
        linkFromStore = storeMap[key];
      }
    }

    const fallback = this.state.devices[device.id]?.link ?? null;
    const effective = (linkFromStore ?? fallback) || null;

    console.log('[ModificaOspite] resolveDeviceLink — deviceId:', device.id, 'serial:', serial, 'storeLink:', linkFromStore, 'fallback:', fallback, 'effective:', effective);
    return effective;
  };

  // Chiede allo store di fetchare e mettere in cache il link; se non presente lo farà arrivare asincronamente
  requestLinkFromStore = (device) => {
    const guestId = this.state.guest?.id;
    const serial  = device?.serialNumber ? String(device.serialNumber).trim() : '';
    if (!guestId || !serial) return;

    if (typeof this.props.fetchGuestLink === 'function') {
      console.log('[ModificaOspite] requestLinkFromStore — fetching via store', { guestId, serial });
      this.props.fetchGuestLink(guestId, serial);
    } else if (typeof this.props.readGuestLinkForDevice === 'function') {
      // Fallback al vecchio metodo che ritorna la stringa
      console.log('[ModificaOspite] requestLinkFromStore — fallback direct lookup');
      this.props.readGuestLinkForDevice(guestId, serial).then(link => {
        console.log('[ModificaOspite] fallback lookup link:', link);
        if (!link) return;
        this.setState(prev => ({
          devices: {
            ...prev.devices,
            [device.id]: { ...(prev.devices[device.id] || device), link }
          }
        }));
      });
    }
  };

  /* ======================
   * Event handlers
   * ====================== */
  onConferma = (save) => {
    console.log('[ModificaOspite] onConferma save:', save);
    if (save) {
      const guest = { ...this.state.guest, devices: [] };
      for (const [, device] of Object.entries(this.state.devices)) {
        guest.devices.push({
          deviceId: device.id,
          deviceName: device.name,
          untilDate: device.limitedDate ? device.limitedDate : 'unlimited'
        });
      }
      console.log('[ModificaOspite] registerUser payload:', guest);
      this.props.registerUser?.(guest);
    }

    this.props.setGeneratedPin?.(1, null);
    this.props.editGuest?.(null);

    this.setState({
      devices: {},
      section: 'dettagli',
      checkDevices: false,
      selectedDevice: null,
      guest: {}
    }, () => console.log('[ModificaOspite] onConferma — state reset done'));

    setTimeout(() => {
      this.props.readUsers?.(true);
      this.props.getAllDevices?.();
    }, 500);
  };

  onAbilita = (device, enable) => {
    console.log('[ModificaOspite] onAbilita — deviceId:', device.id, 'enable:', enable);
    this.setState(prev => {
      const devices = { ...prev.devices };
      if (enable) {
        devices[device.id] = { ...device, limited: null };
        delete devices[device.id].limitedDate;
      } else {
        delete devices[device.id];
      }
      return { devices };
    });
  };

  setLimitedOnDevice = (device, limited) => {
    console.log('[ModificaOspite] setLimitedOnDevice — deviceId:', device.id, 'limited:', limited);
    this.setState(prev => {
      const devices = { ...prev.devices };
      if (!devices[device.id]) devices[device.id] = { ...device };
      if (limited) {
        devices[device.id] = {
          ...devices[device.id],
          limited: true,
          limitedDate: devices[device.id].limitedDate || this.nowLocalForInput()
        };
      } else {
        const { limitedDate, ...rest } = devices[device.id];
        devices[device.id] = { ...rest, limited: null };
      }
      return { devices };
    });
  };

  changeDeviceLimitedDate = (deviceId, e) => {
    const value = e.currentTarget.value;
    console.log('[ModificaOspite] changeDeviceLimitedDate — deviceId:', deviceId, 'value:', value);
    this.setState(prev => {
      if (!prev.devices[deviceId]) return null;
      return {
        devices: {
          ...prev.devices,
          [deviceId]: { ...prev.devices[deviceId], limited: true, limitedDate: value }
        }
      };
    });
  };

  onChangeGuestInfo = (infoKey, value) => {
    console.log('[ModificaOspite] onChangeGuestInfo —', infoKey, value);
    this.setState(prev => ({ guest: { ...prev.guest, [infoKey]: value } }));
  };

  onSendSMS = (device) => {
    const info = {
      user: `${this.state.guest.name || ''} ${this.state.guest.lastName || ''}`.trim(),
      pins: String(this.state.guest.pin?.[0] || ''),
      expirationDates: device?.limitedDate ? device.limitedDate : 'illimitato',
      accessPoint: device?.name || '',
      number: this.state.guest.cellNumber || ''
    };
    console.log('[ModificaOspite] onSendSMS payload:', info);
    this.props.sendSMS?.(info);
  };

  onDelete = () => {
    console.log('[ModificaOspite] onDelete guestId:', this.state.guest.id);
    this.props.setShowModaleConferma?.({
      header: 'Elimina ospite',
      body: "Procedere con l'eliminazione?",
      esegui: () => {
        this.props.onDeleteGuest?.(this.state.guest.id);
        this.props.setShowModaleConferma?.(null);
      }
    });
  };

  onGeneraLink = async (device) => {
    const guestId = this.state.guest?.id;
    const serial  = device?.serialNumber ? String(device.serialNumber).trim() : '';
    console.log('[ModificaOspite] onGeneraLink — deviceId:', device.id, 'serial:', serial, 'guestId:', guestId);

    if (!guestId || !serial) return;

    const res  = await this.props.createGuestLinkForGuest?.(guestId, serial);
    const link = (res && (res.link ?? res?.result?.link)) || null;
    console.log('[ModificaOspite] onGeneraLink response link:', link);

    if (!link) return;

    // Aggiorna locale per immediatezza
    this.setState(prev => {
      const updated = { ...(prev.devices[device.id] || device), link };
      const next = { ...prev.devices, [device.id]: updated };
      console.log('[ModificaOspite] onGeneraLink setState — updated device:', updated);
      return { devices: next };
    });

    // Chiedi anche allo store di aggiornarsi (se esiste fetchGuestLink, userà la stessa chiave)
    if (typeof this.props.fetchGuestLink === 'function') {
      this.props.fetchGuestLink(guestId, serial);
    }
  };

  onRimuoviLink = async (device) => {
    const guestId = this.state.guest?.id;
    const serial  = device?.serialNumber ? String(device.serialNumber).trim() : '';
    console.log('[ModificaOspite] onRimuoviLink — deviceId:', device.id, 'serial:', serial, 'guestId:', guestId);

    if (!guestId || !serial) return;

    const ok = await this.props.deleteGuestLinkForGuest?.(guestId, serial);
    console.log('[ModificaOspite] onRimuoviLink response ok:', ok);

    if (ok === false) return;

    // Pulisci locale
    this.setState(prev => {
      const next = { ...prev.devices };
      if (next[device.id]) {
        const { link, ...rest } = next[device.id];
        next[device.id] = rest;
      }
      console.log('[ModificaOspite] onRimuoviLink setState — next device state:', next[device.id]);
      return { devices: next };
    });

    // Chiedi anche allo store (se presente) di aggiornare la cache
    if (typeof this.props.fetchGuestLink === 'function') {
      this.props.fetchGuestLink(guestId, serial); // tornerà null => si riflette nel Map
    }
  };

  onCopyLink = async (code) => {
    console.log('[ModificaOspite] onCopyLink code:', code);
    if (!code) return;
    const fullUrl = `${ACCESS_LINK_BASE}${code}`;
    try {
      if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(fullUrl);
      else {
        const ta = document.createElement('textarea');
        ta.value = fullUrl; ta.setAttribute('readonly', ''); ta.style.position = 'absolute'; ta.style.left = '-9999px';
        document.body.appendChild(ta); ta.select(); document.execCommand('copy'); document.body.removeChild(ta);
      }
      this.setState({ linkCopied: true });
      setTimeout(() => this.setState({ linkCopied: false }), 1200);
    } catch (err) {
      console.error('[ModificaOspite] onCopyLink failed', err);
    }
  };

  /* ======================
   * Render helpers
   * ====================== */
  renderRfidsOptions = () =>
    (this.props.availablesRfids || []).map(rfid => (
      <option key={rfid.id} value={rfid.id}>{rfid.name}</option>
    ));

  renderDeviceRow = (device) => {
    const isSelected  = this.state.selectedDevice === device.id;
    const enabled     = device.id in this.state.devices;
    const deviceState = this.state.devices[device.id];

    const deviceLink  = this.resolveDeviceLink(device);

    console.log('[ModificaOspite] renderDeviceRow — deviceId:', device.id, 'isSelected:', isSelected, 'enabled:', enabled, 'link:', deviceLink);

    return (
      <React.Fragment key={device.id}>
        <div
          className="device"
          onClick={() =>
            this.setState(
              s => ({ selectedDevice: s.selectedDevice !== device.id ? device.id : null }),
              () => {
                const isNowSelected = this.state.selectedDevice === device.id;
                console.log('[ModificaOspite] device header clicked — deviceId:', device.id, 'isNowSelected:', isNowSelected);
                if (isNowSelected) this.requestLinkFromStore(device); // chiede allo store di popolare
              }
            )
          }
        >
          {isSelected ? (
            <><i className="fa-solid fa-angle-down"></i> <strong>{device.name}</strong></>
          ) : (
            <><i className="fa-solid fa-chevron-right"></i> {device.name}</>
          )}
          {enabled ? <i className="fa-solid fa-circle-check ml-1 text-success"></i> : <i className="fa-solid fa-ban ml-1 text-danger"></i>}
        </div>

        {isSelected && (
          <div className="device-details">
            {enabled ? (
              <>
                <button id="remove-permission" onClick={() => this.onAbilita(device, false)}>
                  <i className="fa-solid fa-ban"></i> DISABILITA
                </button>

                <div id="lim-unlim">
                  <div
                    onClick={() => this.setLimitedOnDevice(device, false)}
                    className={deviceState?.limited == null ? 'selected' : ''}
                  >
                    <label id="device-details-unlimited-btn">ILLIMITATO</label>
                  </div>

                  <div
                    onClick={() => this.setLimitedOnDevice(device, true)}
                    className={deviceState?.limited != null ? 'selected' : ''}
                  >
                    <label id="device-details-until-btn">FINO AL...</label>
                    <input
                      type="datetime-local"
                      id={`input-date-${device.id}`}
                      value={deviceState?.limitedDate || ''}
                      min={this.nowLocalForInput()}
                      onChange={(e) => this.changeDeviceLimitedDate(device.id, e)}
                    />
                  </div>
                </div>

                {/* === LINK DI ACCESSO === */}
                <div className="device-link-block">
                  <div className="device-link-title">
                    <i className="fa-solid fa-link"></i>
                    <span>Link di accesso</span>
                  </div>

                  <div className="link-center">
                    {deviceLink ? (
                      <a
                        className="guest-link"
                        href={`${ACCESS_LINK_BASE}${deviceLink}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        title={`${ACCESS_LINK_BASE}${deviceLink}`}
                      >
                        {deviceLink}
                      </a>
                    ) : (
                      <span className="guest-link placeholder">Nessun link</span>
                    )}

                    <button
                      className="btn-ui primary copy"
                      onClick={() => this.onCopyLink(deviceLink)}
                      disabled={!deviceLink}
                      title="Copia il link completo"
                    >
                      {this.state.linkCopied
                        ? (<><i className="fa-solid fa-check"></i> Copiato!</>)
                        : (<><i className="fa-regular fa-copy"></i> Copia</>)
                      }
                    </button>
                  </div>

                  <div className="link-actions">
                    <button className="btn-ui primary" onClick={() => this.onGeneraLink(device)}>
                      {deviceLink
                        ? (<><i className="fa-solid fa-arrows-rotate"></i> Rigenera</>)
                        : (<>Genera</>)
                      }
                    </button>
                    <button className="btn-ui danger" onClick={() => this.onRimuoviLink(device)}>Rimuovi</button>
                  </div>
                </div>

                {/* === INVIA SMS (spostato in fondo) === */}
                <div id="sms" style={{ marginTop: '0.75rem' }}>
                  <button
                    id="sms-btn"
                    disabled={!this.state.guest.cellNumber}
                    onClick={() => this.onSendSMS(deviceState)}
                  >
                    <i className="fa-solid fa-comment-sms"></i> Invia SMS
                  </button>
                </div>
              </>
            ) : (
              <button id="add-permission" onClick={() => this.onAbilita(device, true)}>
                <i className="fa-solid fa-circle-check"></i> ABILITA
              </button>
            )}
          </div>
        )}
      </React.Fragment>
    );
  };

  /* ======================
   * Render
   * ====================== */
  render() {
    const hasGuest = !!this.props.guestToEdit;
    const guest = this.state.guest || {};
    console.log('[ModificaOspite] render — hasGuest:', hasGuest, 'section:', this.state.section, 'devicesKeys:', Object.keys(this.state.devices));

    return hasGuest ? (
      <Modal id="edit-guest" backdrop="static" show={true} onHide={() => this.onConferma(false)}>
        <Modal.Header>
          <Modal.Title id="title">
            <i className="fa-solid fa-address-card"></i> Modifica Ospite
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* Tabs sezioni */}
          <div id="sections">
            <button
              id="dettagli-btn"
              className={`tab-btn ${this.state.section === 'dettagli' ? 'section-selected' : ''}`}
              onClick={() => this.setState({ section: 'dettagli' })}
            >
              DETTAGLI
            </button>
            <button
              id="accesso-btn"
              className={`tab-btn ${this.state.section === 'accesso' ? 'section-selected' : ''}`}
              onClick={() => this.setState({ section: 'accesso' })}
            >
              ACCESSO
            </button>
            <button
              id="permessi-btn"
              className={`tab-btn ${this.state.section === 'permessi' ? 'section-selected' : ''}`}
              onClick={() => this.setState({ section: 'permessi' })}
            >
              PERMESSI
            </button>
          </div>

          {/* DETTAGLI */}
          {this.state.section === 'dettagli' && (
            <div id="guest-details">
              <label>NOME</label>
              <input type="text" value={guest.name || ''} onChange={(e) => this.onChangeGuestInfo('name', e.currentTarget.value)} />

              <label>COGNOME</label>
              <input type="text" value={guest.lastName || ''} onChange={(e) => this.onChangeGuestInfo('lastName', e.currentTarget.value)} />

              <label>EMAIL</label>
              <input type="text" value={guest.email || ''} onChange={(e) => this.onChangeGuestInfo('email', e.currentTarget.value)} />

              <label>CELLULARE</label>
              <input type="text" value={guest.cellNumber || ''} onChange={(e) => this.onChangeGuestInfo('cellNumber', e.currentTarget.value)} />

              <div className="delete-guest-row">
                <button id="elimina-ospite-btn" onClick={this.onDelete}>
                  <i className="fa-solid fa-trash"></i> Elimina
                </button>
              </div>
            </div>
          )}

          {/* ACCESSO */}
          {this.state.section === 'accesso' && (
            <div id="guest-accesso">
              <div className="access-grid">
                {/* PIN */}
                <section className="access-block">
                  <div className="block-title">
                    <i className="fa-solid fa-key"></i>
                    <span>PIN</span>
                  </div>
                  <div className="block-body compact">
                    <div id="pin">
                      <input type="text" id="pin-input" placeholder="PIN" disabled value={guest.pin?.[0] || ''} />
                      <button id="regenerate-btn" className="btn-ui primary" onClick={() => this.props.generatePin?.(1)}>
                        <i className="fa-solid fa-arrows-rotate"></i> Rigenera
                      </button>
                    </div>
                  </div>
                </section>

                {/* TESSERA */}
                <section className="access-block">
                  <div className="block-title">
                    <i className="fa-regular fa-id-badge"></i>
                    <span>Tessera</span>
                  </div>
                  <div className="block-body compact">
                    <div id="rfid">
                      <select
                        value={guest.rfid ?? 'null'}
                        onChange={(e) => this.onChangeGuestInfo('rfid', e.currentTarget.value === 'null' ? null : e.currentTarget.value)}
                      >
                        <option value={'null'}>Nessuna</option>
                        {this.renderRfidsOptions()}
                      </select>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          )}

          {/* PERMESSI */}
          {this.state.section === 'permessi' && (
            <div>
              {(this.props.devices || []).map(this.renderDeviceRow)}
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <div id="btns">
            <button id="cancel-btn" onClick={() => this.onConferma(false)}>Annulla</button>
            <button id="save-btn" onClick={() => this.onConferma(true)}>
              Salva <i className="fa-solid fa-floppy-disk"></i>
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    ) : null;
  }
}

export default ModificaOspite;
export { ModificaOspite };
